const scrollToTopOrHash = () => {
  // Scroll to top if no element exists
  if (window.location.hash.length === 0) {
    window.scrollTo(0, 0);
    return;
  }

  const scrollToElement = window.document.getElementById(window.location.hash.replace('#', ''));

  // Scroll to top if no element found
  if (!scrollToElement) {
    window.scrollTo(0, 0);
    return;
  }

  // Scroll to element
  window.scrollTo(0, scrollToElement.offsetTop);
};

export default scrollToTopOrHash;



// WEBPACK FOOTER //
// ./utils/helpers/scrollToTopOrHash.js